/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_New_TitleInputs */

const vi_warehouse_position_new_title = /** @type {(inputs: Warehouse_Position_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo vị trí mới`)
};

/**

* @param {Warehouse_Position_New_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_new_title = /** @type {((inputs?: Warehouse_Position_New_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_New_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_new_title(inputs)
});